import { render, staticRenderFns } from "./VisitForm.vue?vue&type=template&id=4977c139&scoped=true&"
import script from "./VisitForm.vue?vue&type=script&lang=js&"
export * from "./VisitForm.vue?vue&type=script&lang=js&"
import style0 from "./VisitForm.vue?vue&type=style&index=0&id=4977c139&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4977c139",
  null
  
)

export default component.exports